import axios from "axios";

const { VITE_DRIVE_API_HOST, VITE_DRIVE_API_HOST_INTERNAL } = import.meta.env;

/**
 * Creates an Axios instance that automatically attaches the latest
 * access token from the Redux state.
 *
 * @param {Function} getState - The Redux getState function.
 * @param {boolean} [internal] - Use internal host if true.
 * @returns {AxiosInstance}
 */
export const createLocalAxios = (getState, { internal = false } = {}) => {
  const instance = axios.create({
    baseURL: internal ? VITE_DRIVE_API_HOST_INTERNAL : VITE_DRIVE_API_HOST,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  instance.interceptors.request.use(
    (config) => {
      const token = getState().session?.accessToken || "";
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  return instance;
};
